<template>
	<router-view ref="child" />
</template>
<script>
export default {
	name: 'App',
}
</script>
<style>
:root{
	border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue